import React from 'react'
import PropTypes from 'prop-types'

const ListingsHeader = ({ heading, totalCount }) => {
  return (
    <div className='ListingGroup-headingBlock'>
      <p className='ListingGroup-headingText'>
        {heading}
      </p>
      <span className='ListingGroup-searchResultsCount'>
        {`${totalCount ? totalCount : ''} Results`}
      </span>
    </div>
  )
}

ListingsHeader.propTypes = {
  heading: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired
}

export default ListingsHeader
